import { describeItemEffect, type ItemId } from '../../shared/items.ts';
import type { Inventory } from '../../shared/protocol.ts';
import { $, el } from '../common/dom.ts';
import { icon } from '../common/icons.ts';
import { itemCatalog, itemVisual } from '../common/item-catalog.ts';
import { Modal } from '../common/modal.ts';
import { creatureText } from '../../shared/game-config.ts';

const QUANTITIES = [1, 5, 10];

/** Boutique : s'ouvre au comptoir, avec les objets que vend la carte. */
export class ShopPanel extends Modal {
  private readonly list = $('.shop-list', this.root);
  private readonly onBuy: (item: ItemId, quantity: number) => void;
  private inventory: Inventory | null = null;
  private forSale: ItemId[] = [];

  constructor(onBuy: (item: ItemId, quantity: number) => void) {
    super('#shop');
    this.onBuy = onBuy;
  }

  /** Ouvre la boutique sur les objets vendus ici. */
  show(forSale: ItemId[]): void {
    this.forSale = forSale;
    this.open();
    this.render();
  }

  setInventory(inventory: Inventory): void {
    this.inventory = inventory;
    if (this.isOpen) this.render();
  }

  private render(): void {
    const coins = this.inventory?.coins ?? 0;
    $('.shop-coins', this.root).textContent = String(coins);
    const items = this.forSale.flatMap((id) => itemCatalog.get(id) ?? []);
    if (!items.length) {
      this.list.replaceChildren(el('p', { className: 'shop-empty', textContent: 'Rien à vendre pour le moment. Repassez plus tard !' }));
      return;
    }
    this.list.replaceChildren(...items.map((item) => {
      const { id } = item;
      const owned = this.inventory?.items[id] ?? 0;
      const buttons = QUANTITIES.map((quantity) => {
        const total = item.price * quantity;
        const button = el('button', { disabled: total > coins, title: `${total} pièces` }, `× ${quantity} · ${total} `, icon('coins'));
        button.addEventListener('click', () => this.onBuy(id, quantity));
        return button;
      });
      return el('div', { className: 'shop-item' },
        el('span', { className: 'shop-icon' }, itemVisual(item)),
        el('div', { className: 'shop-info' },
          el('strong', { textContent: item.name }),
          el('small', { textContent: [item.effect.type === 'none' ? '' : describeItemEffect(item.effect), `Dans le sac : ${owned}`].filter(Boolean).join(' · ') }),
          item.description ? el('small', { className: 'muted shop-description', textContent: creatureText(item.description), title: creatureText(item.description) }) : ''),
        el('div', { className: 'shop-buy' }, ...buttons));
    }));
  }
}
